import { FullQALogo } from './Logos'
import './prompt.scss'

export default function Prompt({ children }) {
  return (
    <div className='prompt'>
      <h1>
        <FullQALogo />
      </h1>
      <div className='prompt-content'>{children}</div>
    </div>
  )
}

export { Prompt }
